export default __webpack_public_path__ + "stumbler-first.d2a0c221.mp4";